import { render, staticRenderFns } from "./AssetTypeList.vue?vue&type=template&id=4dbb6dd0&"
import script from "./AssetTypeList.vue?vue&type=script&lang=js&"
export * from "./AssetTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports